/**
 * Farba štítku materiálu v tabuľke dielcov (KOLO 180, návrh D).
 *
 * Rovnaký materiál = rovnaká farba, aby bolo na prvý pohľad vidno, čo
 * ide z jednej dosky a kde sa v zostave zamiešal iný dekor. Farba patrí
 * **poradiu slotu** vo variante (M1 → prvá), takže je stabilná, kým sa
 * sloty neprehodia.
 *
 * Paleta zámerne nemá modrú, fialovú ani zelenú (farby hrúbky hrán
 * v náčrte) a červenú (chyba). Text na podklade má kontrast > 12 : 1.
 */
export interface FarbaMaterialu {
  /** Štvorček pred názvom. */
  stvorcek: string;
  /** Jemný podklad výberu materiálu. */
  podklad: string;
}

export const PALETA_MATERIALOV: readonly FarbaMaterialu[] = [
  { stvorcek: "#C9820A", podklad: "#FBF0D6" }, // jantár
  { stvorcek: "#C2417A", podklad: "#FBE4EE" }, // ružová
  { stvorcek: "#5B6B82", podklad: "#E6EAF0" }, // bridlicová
  { stvorcek: "#8B5E34", podklad: "#F1E7DC" }, // hnedá
  { stvorcek: "#7A8B2A", podklad: "#EEF2DC" }, // olivová
  { stvorcek: "#B8562A", podklad: "#F8E5DC" }, // terakota
];

/** Farba slotu podľa jeho poradia; slot mimo varianty (−1) farbu nemá. */
export function farbaMaterialu(poradieSlotu: number): FarbaMaterialu | null {
  if (poradieSlotu < 0) return null;
  return PALETA_MATERIALOV[poradieSlotu % PALETA_MATERIALOV.length] ?? null;
}
